import lodashUtil from 'lodash';
import { toast } from 'react-toastify'

export function validateForm(activeSchool, i18n) {
  const errorMsg = i18n.schoolInformationValidation;
  let formValid = true;
  let errors = {}
  if (typeof activeSchool.name !== "undefined" && activeSchool.name.trim().length > 0) {
    //Any character other than numebrs can be entered here. minimum of 2 char and max of 200.
    if (!(activeSchool.name).match(/(^(.){2,200}$)/)) {
      formValid = false;
      errors["name"] = errorMsg.schoolNameNoMatch;
    }
  } else {
    formValid = false;
    errors["name"] = errorMsg.schoolNameIsEmpty;
  }

  if (typeof activeSchool.address.line1 !== "undefined" && activeSchool.address.line1.trim().length > 0) {
    //Any character can be entered here.
    if (!(activeSchool.address.line1).match(/^(.){2,200}$/)) {
      formValid = false;
      errors["address"] = errorMsg.addressLineNoMatch;
    }
  } else {
    formValid = false;
    errors["address"] = errorMsg.addressLineIsEmpty;
  }

  if (typeof activeSchool.address.pincode !== "undefined" && activeSchool.address.pincode.trim().length > 0) {
    if (!(activeSchool.address.pincode).match(/(.)+/)) {
      formValid = false;
      errors["pincode"] = errorMsg.pincodeNoMatch;
    }

  } else {
    formValid = false;
    errors["pincode"] = errorMsg.pincodeIsEmpty;
  }
  if (typeof activeSchool.address.country !== "undefined" && activeSchool.address.country.trim().length > 0) {
    if (!(activeSchool.address.country).match(/(.)+/)) {
      formValid = false;
      errors["country"] = errorMsg.countryNoMatch;
    }
  } else {
    formValid = false;
    errors["country"] = errorMsg.countryIsEmpty;
  }

  if (typeof activeSchool.address.city !== "undefined" && activeSchool.address.city.trim().length > 0) {
    if (!(activeSchool.address.city).match(/(.)+/)) {
      formValid = false;
      errors["city"] = errorMsg.cityNoMatch;
    }
  } else {
    formValid = false;
    errors["city"] = errorMsg.cityIsEmpty;
  }

  if (typeof activeSchool.email !== "undefined" && activeSchool.email.trim().length > 0) {
    if (!(activeSchool.email).match(/^([A-Za-z0-9\_\-\.])+\@([A-Za-z0-9\_\-\.])+\.([A-Za-z]{2,4})$/)) {
      formValid = false;
      errors["email"] = errorMsg.emailNoMatch;
    }
  } else {
    formValid = false;
    errors["email"] = errorMsg.emailIsEmpty;
  }

  if (typeof activeSchool.website !== "undefined" && activeSchool.website.trim().length > 0) {
    if (!(activeSchool.website.trim()).match(/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/)) {
      formValid = false;
      errors["website"] = errorMsg.websiteNoMatch;
    }
  }

  return ({ formValid: formValid, errors: errors })
}

export function phoneNumberValidation(i18n, phoneNumber, required) {
  let numberString;
  if (required === true && phoneNumber != undefined && phoneNumber.length == 0) {
    return { validation: false, phoneNumberError: i18n.schoolInformationValidation.phoneNumberIsEmpty };
  }
  if (phoneNumber != undefined) {
    // for (let i = 0; i < phoneNumber.length; i++) {
    //   let char = phoneNumber.charAt(i)
    //   if (char === " ") {
    //     numberString = phoneNumber.substring(i + 1)
    //     break;
    //   }
    // }
    numberString = phoneNumber;
    if (required == true) {
      let phoneNumberError = i18n.schoolInformationValidation.phoneNumberNoMatch
      if (numberString != undefined && numberString.length > 0) {
        let result = numberString.match(/[0-9]/g);
        if (result.length !== 10) {
          return { validation: false, phoneNumberError: phoneNumberError }
        }
      } else if (numberString == undefined || numberString.length === 0) {
        return { validation: false, phoneNumberError: phoneNumberError }
      }
    } else {
      if (numberString != undefined && numberString.length > 0) {
        let result = numberString.match(/[0-9]/g);
        if (result.length !== 10) {
          let phoneNumberError = i18n.schoolInformationValidation.phoneNumberNoMatch
          return { validation: false, phoneNumberError: phoneNumberError }
        }
      }
    }
  }
  return { validation: true, phoneNumberError: "" };
}